import {
  LOBBY_GET_LANGUAGES,
  LOBBY_GET_PARAMS,
  TOGGLE_CONTACTS_MODAL,
  TOGGLE_INFO_MODAL,
  TOGGLE_RULES_MODAL,
  TOGGLE_SPORT_BETS_HISTORY_MODAL,
} from "../constants";

export const getLobbyParams = () => {
  return (dispatch) => {
    dispatch({
      type: LOBBY_GET_PARAMS,
      payload: {},
    });
  };
};

export const fetchLanguage = () => ({
  type: LOBBY_GET_LANGUAGES,
  payload: {},
});

export const toggleInfoModal = (isShow = false) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_INFO_MODAL,
      payload: isShow,
    });
  };
};

export const toggleContactsModal = (isShow = false) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_CONTACTS_MODAL,
      payload: isShow,
    });
  };
};

export const toggleRulesModal = (payload) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_RULES_MODAL,
      payload,
    });
  };
};

export const toggleSportBetsHistoryModal = (isShow = false) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_SPORT_BETS_HISTORY_MODAL,
      payload: isShow,
    });
  };
};
